<template>
  <b-modal
    id="promo-code-users"
    title="Users"
    no-close-on-backdrop
    size="lg"
  >
    <UsersTable
      :selected-users="selectedUsers"
      @users-selection="$emit('users-selection', $event)"
    />
  </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue'
import UsersTable from './UsersTable.vue'

export default {
  components: {
    BModal,
    UsersTable,
  },
  props: {
    selectedUsers: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
